import PropTypes from 'prop-types'

export default function AivySystemMessageIcon({ className }) {
  return (
    <svg
      width='18px'
      height='18px'
      viewBox='0 0 18 18'
      version='1.1'
      className={className}
    >
      <defs>
        <polygon
          id='path-r1f6t6-l91-1'
          points='-1.33226763e-15 -8.8817842e-16 10.14022 -8.8817842e-16 10.14022 8.91481 -1.33226763e-15 8.91481'
        ></polygon>
        <polygon
          id='path-r1f6t6-l91-3'
          points='0 0 5.51975 0 5.51975 3.43078 0 3.43078'
        ></polygon>
        <polygon
          id='path-r1f6t6-l91-5'
          points='-1.77635684e-15 0 6.96805 0 6.96805 8.91575 -1.77635684e-15 8.91575'
        ></polygon>
        <polygon
          id='path-r1f6t6-l91-7'
          points='-1.77635684e-15 0 6.96805 0 6.96805 8.91575 -1.77635684e-15 8.91575'
        ></polygon>
      </defs>
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g id='Aivy' transform='translate(1.000000, 1.000000)'>
          <circle
            id='Oval'
            stroke='#EBF0F5'
            fill='#FFFFFF'
            fillRule='nonzero'
            cx='8'
            cy='8'
            r='8'
          ></circle>
          <g id='Clipped' transform='translate(2.857180, 3.108890)'>
            <mask id='mask-r1f6t6-l91-2' fill='white'>
              <use xlinkHref='#path-r1f6t6-l91-1'></use>
            </mask>
            <g id='Path'></g>
            <path
              d='M10.09952,8.46071 L5.33086,0.15045 C5.27124,0.04667 5.16591,-0.00285 5.06168,0.00012 L5.06146,0.00012 C5.01246,0.00144 4.96389,0.01421 4.92036,0.0393 C4.91446,0.0426 4.90964,0.04777 4.90396,0.05151 C4.88853,0.06186 4.873,0.07187 4.85944,0.08552 C4.84063,0.10401 4.82378,0.12558 4.80956,0.15045 L0.04084,8.46071 C0.01185,8.51111 -0.00084,8.56481 -2.70768325e-06,8.61681 C0.00277,8.77201 0.12626,8.91261 0.29831,8.91451 C0.2994,8.91451 0.30028,8.91481 0.30137,8.91481 L3.55971,8.91481 L5.06168,6.29761 L6.56352,8.91481 L9.83882,8.91481 C10.07052,8.91481 10.21532,8.66251 10.09952,8.46071 Z'
              id='Path'
              fill='#FE79A7'
              mask='url(#mask-r1f6t6-l91-2)'
            ></path>
          </g>
          <g id='Clipped' transform='translate(2.857180, 8.593020)'>
            <mask id='mask-r1f6t6-l91-4' fill='white'>
              <use xlinkHref='#path-r1f6t6-l91-3'></use>
            </mask>
            <g id='Path'></g>
            <path
              d='M5.11801,0 C3.09191,0 1.30557,1.03638 0.24931,2.61318 L0.11281,2.85118 L0.04073,2.97658 C-0.01713,3.07758 -0.00991,3.19118 0.04073,3.27938 C0.04423,3.28538 0.04937,3.29008 0.05309,3.29578 C0.06348,3.31128 0.07365,3.32698 0.08656,3.34038 C0.09356,3.34738 0.10242,3.35258 0.11008,3.35908 C0.122,3.36908 0.13315,3.37998 0.14661,3.38828 C0.15667,3.39428 0.16859,3.39758 0.17942,3.40248 C0.19255,3.40828 0.2048,3.41558 0.21891,3.41948 C0.23094,3.42288 0.24439,3.42288 0.25708,3.42478 C0.27184,3.42698 0.28584,3.43088 0.30138,3.43088 L3.55972,3.43088 L5.51975,0.01518 C5.38686,0.00616 5.2532,0 5.11801,0 Z'
              id='Path'
              fill='#FFB629'
              mask='url(#mask-r1f6t6-l91-4)'
            ></path>
          </g>
          <g id='Clipped' transform='translate(6.029050, 3.108150)'>
            <mask id='mask-r1f6t6-l91-6' fill='white'>
              <use xlinkHref='#path-r1f6t6-l91-5'></use>
            </mask>
            <g id='Path'></g>
            <path
              d='M3.39165,8.91575 L6.66695,8.91575 C6.89775,8.91575 7.04195,8.66555 6.92855,8.46405 L2.15724,0.14918 C2.04043,-0.05034 1.75299,-0.04979 1.63759,0.15127 L-1.77635684e-15,3.00513 L3.39165,8.91575 Z'
              id='Path'
              fill='#4264DC'
              mask='url(#mask-r1f6t6-l91-6)'
            ></path>
          </g>
          <g id='Clipped' transform='translate(6.029050, 3.108150)'>
            <mask id='mask-r1f6t6-l91-8' fill='white'>
              <use xlinkHref='#path-r1f6t6-l91-7'></use>
            </mask>
            <g id='Path'></g>
            <path
              d='M3.39165,8.91575 L6.66695,8.91575 C6.89775,8.91575 7.04195,8.66555 6.92855,8.46405 L2.15724,0.14918 C2.04043,-0.05034 1.75299,-0.04979 1.63759,0.15127 L-1.77635684e-15,3.00513 L3.39165,8.91575 Z'
              id='Path'
              fill='#4264DC'
              mask='url(#mask-r1f6t6-l91-8)'
            ></path>
          </g>
          <path
            d='M7.46436,8.61459 L9.4207,12.0237 L12.696,12.0237 C12.9266,12.0237 13.0709,11.7735 12.9576,11.5721 L12.4581,10.7015 C11.3756,9.4124 9.7579,8.59302 7.94933,8.59302 C7.78581,8.59302 7.62448,8.60149 7.46436,8.61459 Z'
            id='Path'
            fill='#00CEC8'
          ></path>
        </g>
      </g>
    </svg>
  )
}

AivySystemMessageIcon.propTypes = {
  className: PropTypes.string
}
